import { render, staticRenderFns } from "./StyleStepBranch.vue?vue&type=template&id=29516a2a&scoped=true"
import script from "./StyleStepBranch.vue?vue&type=script&lang=js"
export * from "./StyleStepBranch.vue?vue&type=script&lang=js"
import style0 from "./StyleStepBranch.vue?vue&type=style&index=0&id=29516a2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29516a2a",
  null
  
)

export default component.exports